<template>
  <div class="database">
    <div style="margin-bottom: 10px">
      <a-button type="primary" @click="addnewsubject"> 创建试题 </a-button>
    </div>
    <div style="margin-bottom: 10px; display: flex; justify-content: space-between; width: 100%">
      <a-row type="flex">
        <a-col :flex="4" v-if="userRole == 'youwei_admin'">
          <a-tree-select style="width: 160px; margin-right: 10px" v-model="searchInfo.companyId" allowClear
            :treeData="deptLists" :show-checked-strategy="SHOW_PARENT" placeholder="所属公司" :replaceFields="options"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" maxTagCount="1" @change="deptchange">
          </a-tree-select>
        </a-col>
        <a-col :flex="4">
          <a-select v-model="searchInfo.categoryName" @change="oncourseTypeChange" showSearch optionFilterProp="label"
            placeholder="课程类别" style="width: 160px; margin-right: 10px" allowClear>
            <a-select-option :value="index" :label="index" v-for="(item, index) in categoryList" :key="index">
              {{ index }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :flex="4">
          <a-select showSearch optionFilterProp="label" v-model="searchInfo.courseName" placeholder="课程名称"
            style="width: 160px; margin-right: 10px" allowClear>
            <a-select-option :value="item" :label="item" v-for="item,index in allCourseLis" :key="index">
              {{ item }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :flex="4">
          <a-input placeholder="最后操作者" v-model="searchInfo.updateBy" allowClear
            style="width: 160px; margin-right: 10px" />
        </a-col>
        <a-col :flex="4">
          <a-select v-model="searchInfo.type" placeholder="题型" style="width: 160px; margin-right: 10px" allowClear>
            <a-select-option value="1"> 单选 </a-select-option>
            <a-select-option value="2"> 多选 </a-select-option>
            <a-select-option value="3"> 判断 </a-select-option>
          </a-select>
        </a-col>
        <a-col :flex="4">
          <a-button type="primary" @click="search_lis"> 查询 </a-button>
          <a-button @click="refresh"> 重置 </a-button>
        </a-col>
      </a-row>
      <div style="color: #909090; float: right; font-size: 18px; padding-right: 30px">
        共搜索到 <span style="color: red">{{ totalCount }}</span>条数据
      </div>
    </div>
    <div style="margin-bottom: 10px; height: calc(100% - 126px)" ref="mainTable">
      <a-table :data-source="data" bordered :scroll="{ y: tableScrollY }" :pagination="false" rowKey="id">
        <a-table-column title="所属公司" key="deptId" dataIndex="deptId" v-if="userRole=='youwei_admin'">
          <template slot-scope="text,record">
            {{deptObj[record.deptId].title}}
          </template>
        </a-table-column>
        <a-table-column title="课程类别" key="courseInfo" dataIndex="courseInfo">
          <template slot-scope="text, record">
            {{ record.courseInfo[0].categoryName }}
          </template>
        </a-table-column>
        <a-table-column title="课程名称" key="courseInfo" dataIndex="courseInfo">
          <template slot-scope="text, record">
            <a-dropdown placement="bottomLeft">
              <a-button>{{ record.courseInfo[0].courseName
                }}<template v-if="record.courseInfo.length > 1">
                  <a-icon type="caret-down" />
                </template>
              </a-button>
              <a-menu slot="overlay" v-if="record.courseInfo.length > 1">
                <a-menu-item v-for="(item, index) in record.courseInfo" :key="index">
                  {{ item.courseName }}
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </template>
        </a-table-column>
        <a-table-column title="题干" key="content" ellipsis dataIndex="content"> </a-table-column>
        <a-table-column title="最后操作者" key="updateBy" dataIndex="updateBy"></a-table-column>
        <a-table-column title="最后操作时间" key="updateTime" dataIndex="updateTime"></a-table-column>
        <a-table-column title="操作" key="id" dataIndex="id">
          <template slot-scope="text, record">
            <a-button type="link" @click="changeInfo(record)"> 编辑 </a-button>
            <a-divider type="vertical" />
            <template v-if="userRole == 'youwei_admin'">
              <a-button type="link" @click="shareInfo(record)"> 分享 </a-button>
              <a-divider type="vertical" />
            </template>
            <a-button type="link" @click="publish(record)"> 删除 </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <div class="content_main_bot" style='height: auto'>
      <a-pagination show-size-changer :default-current="1" :total="totalCount" :page-size.sync="searchInfo.pageSize"
        @change="onShowPageChange" show-quick-jumper />
    </div>
    <a-modal v-model="copyRowShow" title="试题分享" @ok="copyRowSubmit" width="80%">
      <a-form :label-col="{ span: 8 }" v-if="copyRowShow">
        <a-row :gutter="40" style="width:90%;margin:0 auto;">
          <a-col :span="6">
            所属公司：{{this.deptObj[selectRow.deptId].title}}
          </a-col>
          <a-col :span="6">
            课程类别：{{selectRow.categoryName}}
          </a-col>
          <a-col :span="6">
            <span>课程名称：</span>
            <a-dropdown placement="bottomLeft">
              <a-button>{{ selectRow.courseInfo[0].courseName
                }}<template v-if="selectRow.courseInfo.length > 1">
                  <a-icon type="caret-down" />
                </template>
              </a-button>
              <a-menu slot="overlay" v-if="selectRow.courseInfo.length > 1">
                <a-menu-item v-for="(item, index) in selectRow.courseInfo" :key="index">
                  {{ item.courseName }}
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </a-col>
          <a-col :span="6">
            <span>题型：</span>
            <span v-if="selectRow.type==1">单选</span>
            <span v-if="selectRow.type==2">多选</span>
            <span v-if="selectRow.type==3">判断</span>
          </a-col>
        </a-row>
        <a-row :gutter="24" :span="24" style="width:90%;margin:10px auto 0;">
          <a-col>
            题干：{{selectRow.content}}
          </a-col>
        </a-row>
        <a-row :span="24" style="width:90%;margin:0 auto;">
          <a-radio-group v-model="selectRow.singleAnswer" v-if="selectRow.type == 1" disabled>
            <a-row v-for="(item, index) in selectRow.optionInfos" :key="index" :gutter="40" style="margin:6px 0 ">
              <a-col :span="4">
                <a-radio :value="letterLis[index]" disabled> {{ letterLis[index] }}： </a-radio>
              </a-col>
              <a-col :span="20">
                <a-input style="flex: 1" v-model="item.content" disabled></a-input>
              </a-col>
            </a-row>
          </a-radio-group>
          <!-- 多选 -->
          <a-checkbox-group v-model="selectRow.muiltAanswer" v-if="selectRow.type == 2" disabled>
            <a-row v-for="(item, index) in selectRow.optionInfos" :key="index" :gutter="40" style="margin:6px 0 ">
              <a-col :span="2">
                <a-checkbox :value="letterLis[index]" disabled> {{ ' ' }}</a-checkbox>
              </a-col>
              <a-col :span="2">
                <span style="white-space: nowrap;">{{ letterLis[index] }}：</span>
              </a-col>
              <a-col :span="18">
                <a-input style="flex: 1" v-model="item.content" disabled></a-input>
              </a-col>
            </a-row>
          </a-checkbox-group>
          <!-- 判断 -->
          <a-radio-group v-model="selectRow.judgeAnswer" v-if="selectRow.type == 3" disabled>
            <a-row :gutter="40" style="margin:6px 0 ">
              <a-col :span="6">
                <a-radio :value="1" disabled> 对 </a-radio>
              </a-col>
              <a-col :span="6">
                <a-radio :value="2" disabled> 错 </a-radio>
              </a-col>
            </a-row>
          </a-radio-group>
        </a-row>
      </a-form>
      <a-row>
        <a-button @click="autoSelect" type="primary">自动选中</a-button>
      </a-row>
      <a-table :data-source="copyLis" rowKey="companyId" :row-selection="rowSelection" v-if="copyRowShow"
        :pagination="false">
        <a-table-column type="selection"></a-table-column>
        <a-table-column title="所属公司" key="companyId" dataIndex="companyId" width="120px">
          <template slot-scope="text, record">
            {{deptObj[record.companyId].title}}
          </template>
        </a-table-column>
        <a-table-column title="课程类别" key="trainId" dataIndex="trainId">
          <template slot-scope="text, record">
            <a-select v-model="record.courseType" placeholder="课程类别" showSearch optionFilterProp="label"
              style="width:100%;min-width:160px;" @change="onCourseTypeChange(record)">
              <a-select-option :value="item.id" v-for="(item, index) in trainIdObj[record.companyId]" :key="index"
                :label="item.categoryName">
                {{ item.categoryName }}
              </a-select-option>
            </a-select>
          </template>
        </a-table-column>
        <a-table-column title="课程名称" key="courseName" dataIndex="courseName">
          <template slot-scope="text, record">
            <a-select v-model="record.courseIds" mode="multiple" placeholder="课程名称" style="width:100%;min-width:160px;">
              <a-select-option :value="item.id"
                v-for="item in record.courseType?courseLis[record.companyId][record.courseType]:[]" :key="item.id"
                :class="item.issueFlag==2?'selectNoShow':''">
                {{ item.courseName }}
              </a-select-option>
            </a-select>
          </template>
        </a-table-column>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { getQuestionLis, getAllCourse, delQuestionLis, getCategoryLis, getCueseLists, letterLis, addQuestion, getTrainCategoryList } from '../../../api/course'
import { tree_all } from '../../../api/purchase'
export default {
  data() {
    return {
      searchInfo: {
        companyId: undefined,
        categoryName: undefined, // 课程类别
        courseName: undefined, // 课程名称
        updateBy: undefined, // 最后操作者
        type: undefined, // 题型
        pageIndex: 1,
        pageSize: 10, // 每页条数
      },
      totalCount: 0,
      data: [],
      tableScrollY: '',
      allCourseLis: [],
      categoryList: [],
      deptObj: {},
      deptLists: [],
      options: {
        children: 'children',
        title: 'title',
        key: 'deptId',
        value: 'value',
      },
      userInfo: {},
      userRole: '',

      copyRowShow: false,
      selectRow: {},
      letterLis: letterLis,
      trainIdObj: {},
      copyLis: [],
      courseLis: {},
    }
  },
  mounted() {
    this.userInfo = this.$store.getters.userInfo
    for (let i = 0; i < this.userInfo.roles.length; i++) {
      if (this.userInfo.roles[i].roleKey == "youwei_admin") {
        this.userRole = 'youwei_admin'
      }
    }
    this.get_lis()
    this.getCategoryList()
    this.getAllCourseLis({ trainIds: this.searchInfo.trainIds, issueFlag: 1 })
    this.getDeptLists()
    this.$nextTick((res) => {
      this.tableScrollY = this.$refs.mainTable.offsetHeight - 54
    })
  },
  methods: {
    autoSelect() {
      let trainIds = {}
      for (let i = 0; i < this.copyLis.length; i++) {
        if (this.trainIdObj[this.copyLis[i].companyId]) {
          for (let j = 0; j < this.trainIdObj[this.copyLis[i].companyId].length; j++) {
            if (this.selectRow.categoryName == this.trainIdObj[this.copyLis[i].companyId][j].categoryName) {
              this.copyLis[i].courseType = this.trainIdObj[this.copyLis[i].companyId][j].id
              if (!this.courseLis[this.copyLis[i].companyId]) {
                this.courseLis[this.copyLis[i].companyId] = {}
              }
              trainIds[this.copyLis[i].courseType] = this.copyLis[i]
            }
          }
        }
      }
      this.$forceUpdate()
      if (Object.keys(trainIds).length) {
        getCueseLists({ trainIds: Object.keys(trainIds).join(','), issueFlag: 1 }).then((res) => {
          if (res.code != 200) {
            return this.$message.error(res.msg)
          }
          let courseLis = {}
          let courseNameLis = []
          for (let i = 0; i < this.selectRow.courseInfo.length; i++) {
            courseNameLis.push(this.selectRow.courseInfo[i].courseName)
          }
          for (let i = 0; i < res.data.list.length; i++) {
            let item = res.data.list[i]
            if (!courseLis[item.companyId]) {
              courseLis[item.companyId] = {}
            }
            if (!courseLis[item.companyId][item.trainId]) {
              courseLis[item.companyId][item.trainId] = []
            }
            courseLis[item.companyId][item.trainId].push(item)
            if (trainIds[item.trainId] && courseNameLis.includes(item.courseName)) {
              if (!trainIds[item.trainId].courseIds.includes(item.id)) {
                trainIds[item.trainId].courseIds.push(item.id)
              }
            }
          }
          this.courseLis = courseLis
          this.$forceUpdate()
        })
      }
    },
    onCourseTypeChange(row) {
      row.courseIds = []
      if (!this.courseLis[row.companyId]) {
        this.courseLis[row.companyId] = {}
      }
      this.courseLis[row.companyId][row.courseType] = []
      let params = {
        companyId: row.companyId,
        trainIds: row.courseType,
        issueFlag: 1
      }
      getCueseLists(params).then((res) => {
        if (res.code != 200) {
          return
        }
        this.courseLis[row.companyId][row.courseType] = res.data.list
        this.$forceUpdate()
      })
    },
    copyRowSubmit() {
      let request_lis = []
      let optionInfos = []
      for (let i = 0; i < this.selectRow.optionInfos.length; i++) {
        optionInfos.push({
          content: this.selectRow.optionInfos[i].content,
          sortField: this.selectRow.optionInfos[i].sortField,
        })
      }
      for (let i = 0; i < this.copyLis.length; i++) {
        if (this.copyLis[i].courseType && this.copyLis[i].courseIds.length) {
          let params = {
            companyId: this.copyLis[i].companyId,
            courseType: this.copyLis[i].courseType,
            courseIds: this.copyLis[i].courseIds,
            type: this.selectRow.type,
            content: this.selectRow.content,
            answer: this.selectRow.answer,
            uuid: '',
            score: '',
          }
          if (this.selectRow.imgList && this.selectRow.imgList.length) {
            params.uuid = this.selectRow.imgList[0].tempId
          }
          if (this.selectRow.type == 1 || this.selectRow.type == 2) {
            params.score = 2
            params.optionsInfos = optionInfos
          } else {
            params.score = 1
            params.optionsInfos = []
          }
          request_lis.push(new Promise((res, rej) => {
            addQuestion(params).then(reslove => {
              res(reslove)
            })
          }))
        }
      }
      Promise.all(request_lis).then(res => {
        for (let i = 0; i < res.length; i++) {
          if (res[i].code != 200) {
            return this.$message.error(res[i].msg)
          }
        }
        this.$message.success('新增成功')
        this.get_lis()
        this.copyRowShow = false
      })
    },
    shareInfo(row) {
      this.selectRow = row
      if (this.selectRow.type == 1) {
        this.selectRow.singleAnswer = this.selectRow.answer
      } else if (this.selectRow.type == 2) {
        this.selectRow.muiltAanswer = this.selectRow.answer.split(';')
      } else if (this.selectRow.type == 3) {
        this.selectRow.judgeAnswer = Number(this.selectRow.answer)
      }
      let copyLis = []
      let companyIds = []
      let trainIdObj = {}
      for (let i = 0; i < this.deptLists.length; i++) {
        if (row.deptId != this.deptLists[i].deptId) {
          copyLis.push(
            {
              companyId: this.deptLists[i].deptId,
              trainId: undefined,
              courseIds: [],
            }
          )
          companyIds.push(this.deptLists[i].deptId)
          trainIdObj[this.deptLists[i].deptId] = []
        }
      }
      getTrainCategoryList({ companyIds: companyIds.join(',') }).then(res => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        this.copyLis = copyLis
        for (let i = 0; i < res.data.length; i++) {
          trainIdObj[res.data[i].companyId] = res.data[i].list
        }
        this.trainIdObj = trainIdObj
        this.copyRowShow = true
      })
    },
    deptchange() {
      this.searchInfo.categoryName = undefined
      this.searchInfo.courseName = undefined
      this.getCategoryList(this.searchInfo.companyId)
    },
    getDeptLists() {
      let _this = this
      tree_all().then((res) => {
        let deptObj = {}
        if (this.userRole == "youwei_admin") {
          let data = res.data[0]
          for (let i = 0; i < data.length; i++) {
            deptObj[data[i].deptId] = data[i]
          }
          this.deptObj = JSON.parse(JSON.stringify(deptObj))
          function formatDept(lists) {
            for (let i = 0; i < lists.length; i++) {
              if (!_this.userInfo.userPermissions.includes(lists[i].deptId) && !_this.userInfo.userPermissions.includes(String(lists[i].deptId))) {
                lists.splice(i, 1)
                i--
              } else if (lists[i].children && lists[i].children.length) {
                delete lists[i].children
              }
            }
          }
          formatDept(data)
          this.deptLists = data
        } else {
          this.deptLists = res.data[0]
        }
        this.$nextTick((res) => {
          this.get_lis()
        })
      })
    },
    publish(row) {
      let _this = this
      this.$confirm({
        title: '提示',
        content: '是否确认删除?',
        okText: '确定',
        cancelText: '取消',
        onOk() {
          delQuestionLis({
            id: row.id,
          }).then((res) => {
            if (res.code != 200) {
              return _this.$message.error(res.msg)
            }
            _this.$message.success('删除成功')
            _this.get_lis()
          })
        },
        onCancel() {
          _this.$message.info('已取消操作')
        },
      })
    },
    changeInfo(row) {
      this.$router.push({
        path: '/training/database/addsubject?id=' + row.id,
      })
    },
    oncourseTypeChange() {
      this.searchInfo.courseName = undefined
      this.getAllCourseLis({ trainIds: this.categoryList[this.searchInfo.categoryName], issueFlag: 1 })
    },
    getCategoryList(companyId) {
      getCategoryLis({ companyId: companyId }).then((res) => {
        if (res.code != 200) {
          return
        }
        let categoryList = {}
        for (let i = 0; i < res.data.list.length; i++) {
          if (!categoryList[res.data.list[i].categoryName]) {
            categoryList[res.data.list[i].categoryName] = res.data.list[i].id
          } else {
            categoryList[res.data.list[i].categoryName] += ',' + res.data.list[i].id
          }
        }
        this.categoryList = categoryList
      })
    },
    getAllCourseLis(params) {
      getCueseLists(params).then((res) => {
        if (res.code != 200) {
          return
        }
        let allCourseLis = []
        for (let i = 0; i < res.data.list.length; i++) {
          if (!allCourseLis.includes(res.data.list[i].courseName)) {
            allCourseLis.push(res.data.list[i].courseName)
          }
        }
        this.allCourseLis = allCourseLis
      })
    },
    search_lis() {
      this.searchInfo.pageIndex = 1
      this.get_lis()
    },
    refresh() {
      this.searchInfo = {
        companyId: undefined,
        categoryName: undefined, // 课程类别
        courseName: undefined, // 课程名称
        updateBy: undefined, // 最后操作者
        type: undefined,
        pageIndex: 1,
        pageSize: 10, // 每页条数
      }
      this.get_lis()
      this.getAllCourseLis('')
    },
    get_lis() {
      getQuestionLis(this.searchInfo).then((res) => {
        if (res.code != 200) {
          return
        }
        this.data = res.data.list
        this.totalCount = res.data.totalCount
      })
    },
    addnewsubject() {
      this.$router.push({
        path: '/training/database/addsubject',
      })
    },
    onShowPageChange(page, pageSize) {
      this.searchInfo.pageIndex = page
      this.get_lis()
    },
  },
}
</script>

<style scoped lang="less">
.database {
  width: 100%;
  height: 100%;
  padding: 10px 0;
  /deep/ .ant-btn-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  /deep/ .ant-divider {
    background: #1890ff;
  }
  /deep/ .ant-dropdown-trigger {
    width: 100%;
    white-space: pre-wrap;
    display: flex;
    align-items: center;
    padding-left: 0 !important;
    padding-right: 0 !important;
    border: 0;
    background: transparent;
  }
}
</style>